// extracted by mini-css-extract-plugin
export var content = "_7w-1";
export var modal = "_7w-0";